<div class="stepper-body">
    <div class="body-title">
        <span>How will you use this property?</span>
    </div>
    <div class="body-answers custom-answers">
        <div class="custom-container">
            <button mat-stroked-button class="step-option" [ngClass]="{
                            'selected':isBtnSelected(PropertyUsageOptions.Primary)
                        }" (click)="onAnswerSelected(PropertyUsageOptions.Primary)">
                {{PropertyUsageOptions.Primary}}
            </button>
        </div>
        <div class="custom-container">
            <button mat-stroked-button class="step-option" [ngClass]="{
                            'selected':isBtnSelected(PropertyUsageOptions.Second)
                        }" (click)="onAnswerSelected(PropertyUsageOptions.Second)">
                {{PropertyUsageOptions.Second}}
            </button>
        </div>
        <div class="custom-container">
            <button mat-stroked-button class="step-option" [ngClass]="{
                            'selected':isBtnSelected(PropertyUsageOptions.Investment)
                        }" (click)="onAnswerSelected(PropertyUsageOptions.Investment)">
                {{PropertyUsageOptions.Investment}}
            </button>
        </div>
    </div>
</div>
<div class="stepper-footer">
    <mat-divider></mat-divider>
    <div class="step-controls">
        <button mat-stroked-button color="primary"
            (click)="onBack()" class="step-button secondary" [disabled]="false">
            Back
        </button>
        <button mat-flat-button color="primary" (click)="onNext()" class="step-button primary" [disabled]="isNextDisabled()">
            Next
        </button>
    </div>
</div>